/**
 * Full list of supported UI languages — matches legacy `translate.addLangs([...])`
 * (`app.module.ts`) and the 11 locale files under `src/assets/i18n/`. Shared by the
 * navbar's language dropdown (`DefaultLayoutComponent`) and the standalone
 * `/Select-Language` page (`SelectLanguageComponent`) so both stay in sync.
 */
export interface AppLanguage {
  code: string;
  name: string;
}

export const AVAILABLE_LANGUAGES: AppLanguage[] = [
  { code: 'en', name: 'English' },
  { code: 'pl', name: 'Polish' },
  { code: 'zh', name: 'Chinese' },
  { code: 'es', name: 'Spanish' },
  { code: 'sv', name: 'Swedish' },
  { code: 'it', name: 'Italian' },
  { code: 'tr', name: 'Turkish' },
  { code: 'de', name: 'German' },
  { code: 'fr', name: 'French' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'cs', name: 'Czech' },
];
